module.exports = __webpack_public_path__ + "img/wyb_banner_en.124dfcc0.png";